/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for NotificationResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, NotificationDTO } from "../models";

@Injectable({ providedIn: "root" })
export class NotificationResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    notifyUtilisateur(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyUtilisateur1(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur1(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur1(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur1(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyUtilisateur2(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur2(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur2(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur2(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyUtilisateur4(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur4(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur4(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur4(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyUtilisateur3(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur3(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur3(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur3(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyUtilisateur6(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur6(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur6(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur6(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyUtilisateur5(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyUtilisateur5(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyUtilisateur5(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyUtilisateur5(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-utilisateur`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement1(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement1(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement1(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement1(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement2(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement2(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement2(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement2(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement3(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement3(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement3(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement3(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement5(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement5(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement5(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement5(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement4(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement4(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement4(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement4(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement7(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement7(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement7(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement7(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement6(ids: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    notifyEtablissement6(ids: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement6(ids: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement6(ids: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/notify-etablissement`;

        let params = new HttpParams();
        if (ids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ids, 'ids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification1(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification1(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification1(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification2(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification2(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification2(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification2(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification4(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification4(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification4(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification4(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification3(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification3(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification3(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification3(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification6(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification6(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification6(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification6(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllNotification5(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NotificationDTO>>;
    findAllNotification5(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NotificationDTO>>>;
    findAllNotification5(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NotificationDTO>>>;
    findAllNotification5(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-notifications`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
